<script>
export let hotel;	

</script>


<style>

.hotel-thumb {
	display: block;
}

.city-name {
	/*margin-bottom: 0.175rem;*/
	font-size: 1.175rem;
	color: #1f1f1f;
	text-align: center;
}

</style>



<a class="card hotel-thumb" href="{hotel.href}" target="_blank" rel="noopener">

	<div class="card-content">

		<p class="city-name">
			{hotel.city}
		</p>

	</div>

</a>


